export default function isSome(value) {
	return value !== null && value !== undefined;
}
